(() => {
  'use strict';
  const body = document.body;
  const hero = document.querySelector('.hero');
  const motion = document.querySelector('.motion-control');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let manuallyPaused = false;
  function syncMotion() {
    const paused = manuallyPaused || reduced.matches;
    body.classList.toggle('motion-paused', paused);
    motion.hidden = reduced.matches;
    motion.setAttribute('aria-pressed', String(paused));
    motion.innerHTML = paused ? 'Pornește animațiile <span aria-hidden="true">▶</span>' : 'Oprește animațiile <span aria-hidden="true">Ⅱ</span>';
    if (paused) { hero.style.removeProperty('--orchard-x'); hero.style.removeProperty('--orchard-y'); }
  }
  motion.addEventListener('click', () => { manuallyPaused = !manuallyPaused; syncMotion(); });
  reduced.addEventListener('change', syncMotion);
  syncMotion();

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('in-view', entry.isIntersecting));
  }, {threshold:0.05});
  document.querySelectorAll('.hero,.orchard-break').forEach(el => observer.observe(el));
  // Pointer movement changes only decorative assets; no layout changes or touch interception.
  let pointerFrame = 0;
  hero.addEventListener('pointermove', event => {
    if (event.pointerType !== 'mouse' || reduced.matches || manuallyPaused) return;
    if (pointerFrame) cancelAnimationFrame(pointerFrame);
    pointerFrame = requestAnimationFrame(() => {
      if (reduced.matches || manuallyPaused) { pointerFrame = 0; return; }
      const box = hero.getBoundingClientRect();
      hero.style.setProperty('--orchard-x', `${((event.clientX-box.left)/box.width-.5)*16}px`);
      hero.style.setProperty('--orchard-y', `${((event.clientY-box.top)/box.height-.5)*12}px`);
      pointerFrame = 0;
    });
  });
  hero.addEventListener('pointerleave', () => {
    if (pointerFrame) cancelAnimationFrame(pointerFrame);
    hero.style.removeProperty('--orchard-x');hero.style.removeProperty('--orchard-y');
  });

  const filters = [...document.querySelectorAll('[data-filter]')];
  const cards = [...document.querySelectorAll('[data-package]')];
  const grid = document.querySelector('.cards');
  const status = document.querySelector('#filter-status');
  document.querySelector('.package-tools').hidden = false;
  filters.forEach(button => button.addEventListener('click', () => {
    const selection = button.dataset.filter;
    filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    cards.forEach(card => {card.hidden = selection !== 'all' && card.dataset.package !== selection;});
    grid.classList.toggle('is-filtered', selection !== 'all');
    status.textContent = selection === 'all' ? '3 tipuri de pachete' : `Vezi: ${button.textContent.toLowerCase()}`;
  }));

  const dock = document.querySelector('.signup-dock');
  const signup = document.querySelector('#noutati');
  const footer = document.querySelector('footer');
  const progress = document.querySelector('.reading-progress');
  let scrolling = false;
  function syncScroll() {
    const total = document.documentElement.scrollHeight - innerHeight;
    progress.style.transform = `scaleX(${total > 0 ? Math.min(1,Math.max(0,scrollY/total)) : 0})`;
    const signupBox = signup.getBoundingClientRect();
    const signupVisible = !signup.hidden && signupBox.top < innerHeight && signupBox.bottom > 0;
    const home = document.querySelector('[data-bf-home]');
    const ended = home && home.dataset.bfPhase === 'ended';
    dock.hidden = hero.getBoundingClientRect().bottom > 0 || signupVisible || footer.getBoundingClientRect().top < innerHeight || ended;
    scrolling = false;
  }
  function requestScroll() {if(!scrolling){scrolling=true;requestAnimationFrame(syncScroll);}}
  addEventListener('scroll',requestScroll,{passive:true});
  addEventListener('resize',requestScroll,{passive:true});
  document.addEventListener('bf:phasechange', requestScroll);
  filters.forEach(button => button.addEventListener('click',requestScroll));
  new ResizeObserver(requestScroll).observe(document.body);
  syncScroll();
})();
